/**
 * @description: 工单详情右侧 处理记录列表
 * @author:
 */
<template>
  <div class="page" :class="{'show-pagination': page.total > page.size}" v-page-loading="loading">
    <div v-if="listData.length">
      <div class="table-view">
        <div class="table-block" v-for="item in listData" :key="item.id">
          <div class="table-header">
            <div class="row-box" v-for="(row, key) in option.head" :key="key">
              <div class="item" v-for="header in row" :key="header.prop" :style="getStyle(header)">
                <div class="key" :style="{width: header.labelWidth ? (header.labelWidth + 'px') : 'auto'}">{{header.label}}：</div>
                <div class="value">{{typeof header.formatter === 'function' ? header.formatter(item) : item[header.prop]}}</div>
              </div>
            </div>
          </div>
          <div class="table-content">
            <template v-for="content in option.column">
              <div class="row-box" :key="content.prop" v-if="typeof content.hide === 'function' ? content.hide(item) : true">
                <div class="item">
                  <div class="key" :style="{width: content.labelWidth ? (content.labelWidth + 'px') : 'auto'}">
                    {{content.label ? `${content.label}：` : ''}}</div>
                  <div v-if="content.img" class="value img-box">
                    <div v-for="{id, url, name, icon} in content.formatter(item)" :key="id" class="img-item">
                      <div class="file-type iconfont file-icon" :class="icon" v-if="icon" @click="download(url)" :title="$lang('下载')" />
                      <el-image v-else style="width: 100px; height: 100px" :src="url" :preview-src-list="content.formatter(item).map(o=>o.url)"
                        fit="cover" @click="showImage(url, content.formatter(item))" />
                      <div v-if="name" class="img-name">{{name}}</div>
                    </div>
                  </div>
                  <div class="value" v-else>{{typeof content.formatter === 'function' ? content.formatter(item) : item[content.prop]}}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- <div class="pagination" :class="{rightText: page.right}">
        <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="page.current" :page-size="page.size"
          layout="total, prev, next" :total="page.total" hide-on-single-page background>
        </el-pagination>
      </div> -->
    </div>
    <avue-empty v-else :loadingState="2" size="50"
      image="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
      :desc="$lang('暂无数据')"></avue-empty>
  </div>
</template>

<script>
import { RESPONSE_CODE } from '@public/http/config'
import { detailView } from '../pool'

export default {
  data() {
    return {
      loading: false,
      listData: [],
      page: {
        size: 20,
        current: 1,
        total: 0
      }
    }
  },
  props: {
    option: Object,
    value: Array
  },
  watch: {
    value(list) {
      if (list) {
        this.listData = list
      }
    }
  },
  created() {
    if (this.value) {
      this.listData = this.value
    } else {
      this.reqData()
    }
    this.$bus.$on('handleListRefresh', this.reqData)
  },
  methods: {
    // handlePageChange(current) {
    //   this.page.current = current
    //   this.reqData()
    // },
    // handleSizeChange(size) {
    //   this.page.size = size
    //   this.page.current = 1
    //   this.reqData()
    // },
    async reqData() {
      const { id } = this.$route.params
      this.listData = []
      this.loading = true
      if (!id) return
      try {
        const { code, data, msg } = await detailView.reqTaskOperateRecordNew({ taskId: id })
        this.loading = false
        if (code === RESPONSE_CODE.SUCCESS) {
          if (data) {
            this.listData = data || []
          }
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        this.loading = false
      }
    },
    getStyle(item) {
      const style = {}
      if (item.width) {
        style.flexBasis = item.width + 'px'
      } else if (item.size) {
        style.flexBasis = item.size + '%'
      }
      return style
    },
    showImage(url, list) {
      const urlList = list.filter(o => o.url.match(/\.(jpg|png|jpeg)/i)).map(o => o.url)
      const index = urlList.indexOf(url)
      this.$openImagePreview(urlList, index === -1 ? 0 : index)
    },
    download(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  &.show-pagination {
    padding-bottom: 50px;
    .table-view {
      height: calc(100vh - 250px);
    }
  }
}
.table-view {
  overflow-y: auto;
  position: relative;
}

.table-block {
  margin-bottom: 10px;
  border: 1px solid #ddd;
  @include border-color('lighter');
  .table-header {
    border-bottom: 1px solid #ddd;
    background-color: #fafafa;
    @include bg-color('light');
    @include border-color('lighter');
    font-size: 12px;
    line-height: 18px;
    padding: 10px 20px;
    margin-bottom: -1px;
  }

  .table-content {
    font-size: 14px;
    padding: 20px;
    .row-box + .row-box {
      margin-top: 15px;
    }
  }

  .row-box {
    display: flex;
    flex-wrap: wrap;
    .item {
      flex: 0 2 auto;
      display: flex;
      .key {
        width: 80px;
        @include text-color('subtitle');
      }
      .value {
        flex: 1;
        word-break: break-all;
        white-space: pre-line;
        @include text-color('routine');
      }
      .img-box {
        overflow: hidden;
        margin-bottom: -20px;
      }
      .img-item {
        float: left;
        width: 100px;
        margin-right: 20px;
        margin-bottom: 20px;
        overflow: hidden;
        font-size: 0;

        .el-image {
          border-radius: 5px;
        }

        .file-icon {
          font-size: 30px;
          @include base-color('clr');
          width: 100px;
          height: 100px;
          text-align: center;
          border: 1px solid #ddd;
          border-radius: 6px;
          box-sizing: border-box;
          &:after {
            content: '';
            vertical-align: middle;
            height: 100%;
            display: inline-block;
          }
        }
      }
      .img-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        line-height: 20px;
        color: #999;
      }
    }
  }
}

.pagination {
  position: absolute;
  bottom: 0;
  &.rightText {
    right: 0;
  }
}
</style>
